import { ApiResponse } from 'app/types-shared';
import { RemoteAdminData } from 'app/infrastructure/remote-data';
import { endpoints } from './endpoints';
import { CodetablesAccessWire, ListBranchModel } from './types-store';
import { CodeFieldWireKey, CodetableMetadataWire, LinkCodesActionWire, ListBranchWire } from './types';

export const api = {
  loadMetadata: async (id: number): Promise<CodetableMetadataWire> => {
    const request = await new RemoteAdminData(endpoints.codetableMetadata(id))
      .resource<ApiResponse<CodetableMetadataWire>>()
      .single();

    return request.data;
  },

  loadCodetablesAccess: async (codetableId: number): Promise<CodetablesAccessWire> => {
    const request = await new RemoteAdminData(endpoints.codetablesAccess)
      .resource<ApiResponse<CodetablesAccessWire>>()
      .filter({ id: codetableId })
      .single();
    return request.data;
  },

  loadListBranch: async (
    model: ListBranchModel, id: number,
    startIndex: number, maxResults: number,
    includeSubtables: CodeFieldWireKey[]
  ): Promise<ListBranchWire> => {

    const response = await new RemoteAdminData(endpoints.codetableSearch(model.codetable))
      .resource<Response>()
      .filter({
        'api-version': '3.0',
        ...(startIndex !== undefined && { startIndex }),
        ...(maxResults !== undefined && { maxResults }),
        ...(id !== undefined && { parentId: id })
      })
      .create({
        ...(model.category !== undefined && { category: { selectedIds: [{ v: model.category }] } }),
        includeInactiveCodes: { enabled: model.includeInactiveCodes },
        limitFieldsTo: [CodeFieldWireKey.code, CodeFieldWireKey.colour, CodeFieldWireKey.icon],
        includeSubtables
      });

    const json = await response.json();

    return json.data;
  },

  saveChanges: (actions: LinkCodesActionWire[], endpoint: string) => {
    return new RemoteAdminData(endpoint)
      .resource<void>()
      .filter({ 'api-version': '3.0' })
      .update({ actions });
  }
};
